import { Routes } from '@angular/router';
import { RouteAccessGuard } from '@app/core/guards/route-access.guard';
import { AvailabilityComponent } from './availability.component';
import { Authority } from '@app/shared/utils/enums';

export const availabilityRoutes: Routes = [
    {
        path: 'availability',
        children: [
            {
                path: '',
                component: AvailabilityComponent,
                data: {
                    authorities: [Authority.ADMIN]
                }
                //,canActivate: [RouteAccessGuard]
            }
        ]
    }
]